export default __webpack_public_path__ + "static/media/student.959eac69.png";